import { createSelector } from 'reselect';
import InterchangeProcessingSummaryColumns
  from '../../containers/InterchangeProcessingSummaryColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .INTERCHANGE_PROCESSING_SUMMARY.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .INTERCHANGE_PROCESSING_SUMMARY.isLoading;

export const getData =
  ReportDefinitions
    .INTERCHANGE_PROCESSING_SUMMARY.getDataFunction();

export const getColumns =
  createSelector(getData, InterchangeProcessingSummaryColumns);
